<template>
    <div style="height: 100%">
        <div class="sa-flexbox" style="padding-bottom: 20px">
            <div class="sa-flexbox-body">
                <div class="b-table-sticky-header">
                    <b-button size="sm" variant="outline-success outline-secondary-noborder pull-right float-right" style="margin-bottom: 5px" @click="onClickAggiungiIndirizzo()">
                        <i class="fas fa-plus"></i>
                        Aggiungi
                    </b-button>
                    <b-table sticky-header ref="table" stacked="xl" striped hover select-mode="multi" :items="items" :fields="fields" :current-page="currentPage" :per-page="perPage" sort-icon-right head-variant="light" class="sa-b-table">
                        <template #cell(index)="row">
                            {{ (currentPage - 1) * perPage + row.index + 1 }}
                        </template>
                        <template v-slot:cell(actions)="row">
                            <b-container class="bv-example-row">
                                <b-button v-b-tooltip.hover size="sm" variant="outline-success" title="Modifica Indirizzo" @click="onEdit(row.item)" class="mr-1 no-text">
                                    <font-awesome-icon icon="edit"> </font-awesome-icon>
                                </b-button>
                                <b-button v-b-tooltip.hover size="sm" variant="outline-danger" title="Cancella Indirizzo" @click="onDelete(row.item)" class="mr-1 no-text">
                                    <font-awesome-icon icon="trash"></font-awesome-icon>
                                </b-button>
                            </b-container>
                        </template>
                    </b-table>
                </div>
            </div>
            <div class="sa-list-component-footer">
                <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                    <b-col lg="3">
                        <p>{{ this.$i18n.t("patients.lblTotalRecords") }}: {{ rows }}</p>
                    </b-col>
                    <b-col lg="9">
                        <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
                    </b-col>
                </b-row>
            </div>
        </div>
        <contabilita-soggetto-altri-indirizzi-modal-edit-component ref="cmpContabilitaSoggettoAltriIndirizziModalEdit" @afterSave="afterSave"></contabilita-soggetto-altri-indirizzi-modal-edit-component>
    </div>
</template>
<script>
import UtilityMixin from "../../utility/UtilityMixin";
import ContabilitaSoggettoAltriIndirizziModalEditComponent from "./ContabilitaSoggettoAltriIndirizziModalEditComponent.vue";
export default {
    mixins: [UtilityMixin],
    components: { ContabilitaSoggettoAltriIndirizziModalEditComponent },
    data() {
        return {
            currentPage: 1,
            rows: 0,
            perPage: 50,
            pathResource: "/contabilitasoggettoaltriindirizzi",
            items: [],
            isEdit: false,
            fields: [
                {
                    label: "N.",
                    key: "index",
                    thStyle: "width: 3rem",
                },
                {
                    label: "Descrizione",
                    key: "altriIndirizziDescrizione",
                },
                {
                    label: "Indirizzo",
                    key: "altriIndirizziIndirizzo",
                },
                {
                    label: "Comune",
                    key: "comune",
                    thStyle: "width: 5rem",
                },
                {
                    label: "Provincia",
                    key: "provincia",
                },

                { class: "sa-table-column-action-double", key: "actions", label: "" },
            ],
        };
    },
    methods: {
        refresh(filter) {
            let me = this;
            me.loadData(filter);
        },
        loadData(id) {
            let me = this;
            me.$emit("beforeLoadData");
            let filtro = {
                idSoggetto: id,
                perPage: me.perPage,
                page: me.currentPage,
            };
            UtilityMixin.methods.loadDataResources(me.pathResource, filtro, me.loadDataSuccess, me.loadDataError);
        },
        loadDataSuccess(response) {
            let me = this;
            me.items = response.data.data.list;
            me.rows = response.data.data.recordsNumber;
            me.$emit("afterLoadData");
        },
        loadDataError(error) {
            let me = this;
            error;
            me.$emit("afterLoadData");
        },
        onEdit(item) {
            let me = this;
            me.isEdit = true;
            me.$refs.cmpContabilitaSoggettoAltriIndirizziModalEdit.show(item, me.isEdit);
        },
        onClickAggiungiIndirizzo() {
            let me = this;
            me.isEdit = false;
            me.$refs.cmpContabilitaSoggettoAltriIndirizziModalEdit.show(
                {
                    codiceAzienda: "",
                    altriIndirizziDescrizione: "",
                    altriIndirizziCap: "",
                    altriIndirizziLocalita: "",
                    altriIndirizziIndirizzo: "",
                    ordering: "",
                    idSoggetto: me.$route.params.id,
                },
                me.isEdit,
            );
        },
        afterSave() {
            let me = this;
            me.loadData(me.$route.params.id);
        },
        onDelete(item) {
            let me = this;
            me.$bvModal
                .msgBoxConfirm("Sei sicuro di eliminare questo  indirizzo ?", {
                    title: "Eliminazione Altri Indirizzi",
                    buttonSize: "sm",
                    okTitle: "SI",
                    cancelTitle: "NO",
                    okVariant: "danger",
                    cancelVariant: "secondary",
                    hideHeaderClose: true,
                    footerClass: "p-2",
                    centered: true,
                })
                .then((value) => {
                    if (value) {
                        me.deleteAltriIndirizzi(item.id);
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        deleteAltriIndirizzi(id) {
            let me = this;
            me.$emit("beforeLoadData");
            UtilityMixin.methods.deleteResource(me.pathResource + "/" + id, me.loadDataDeleteSuccess, me.loadDataDeleteError);
        },
        loadDataDeleteSuccess(response) {
            let me = this;
            response;
            me.$bvToast.toast("Eliminazione avvenuta con successo", {
                title: "Successo",
                variant: "success",
                solid: true,
            });
            me.loadData(me.$route.params.id);
        },
        loadDataDeleteError(error) {
            let me = this;
            error;
            me.$emit("afterLoadData");
        },
    },
};
</script>
